import React from 'react'
import PropTypes from 'prop-types'
import Flex from 'components/UI/Flex/Flex'
import CounterInput from '../../../../../UI/CounterInput/CounterInput'
import DatePicker from 'react-datepicker' // Убедитесь, что вы импортировали DatePicker
import 'react-datepicker/dist/react-datepicker.css' // Импорт стилей для DatePicker
import slotsScheduleSettingsStore from 'Stores/slotsScheduleSettingsStore'
import styles from './TimeSlots.module.scss'
import { getAdaptedTime } from 'components/Modules/Slots/utils'
import { timeConverter } from '../../../../../ContentBox/Online-schedule/components/functions'
import { addZero } from '../../../../../../helpers/math'

function TimeSlot({ start, end, count }) {
  const { setSlotCount, selectedLocation, changeValues } =
    slotsScheduleSettingsStore
  const shiftedStart = getAdaptedTime(start, selectedLocation.time_zone)
  const shiftedEnd = getAdaptedTime(end, selectedLocation.time_zone)

  const handleInputChange = (evt) => {
    setSlotCount(evt, start)
  }

  return (
    <li className={styles.slot_wrapper}>
      <div className={styles.datetime_box}>
        <DatePicker
          disabled
          selected={shiftedStart && new Date('2020-01-01 ' + shiftedStart)}
          timeCaption='Начало'
          onChange={(date) => {
            changeValues(
              timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`,
              'start_at',
            )
          }}
          onSelect={(date) => {
            changeValues(
              timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`,
              'start_at',
            )
          }}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeFormat='HH:mm'
          dateFormat='HH:mm'
          className={styles.datepicker_input}
        />
        <div className={styles.datetimeBoxMiddle}>-</div>
        <DatePicker
          disabled
          selected={shiftedEnd && new Date('2020-01-01 ' + shiftedEnd)}
          timeCaption='Конец'
          onChange={(date) => {
            changeValues(
              timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`,
              'finish_at',
            )
          }}
          onSelect={(date) => {
            changeValues(
              timeConverter(date, 'time') + `:${addZero(date.getSeconds())}`,
              'finish_at',
            )
          }}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeFormat='HH:mm'
          dateFormat='HH:mm'
          className={styles.datepicker_input}
        />
      </div>
      <CounterInput
        value={count}
        min={0}
        max={50}
        step={1}
        name='slotCount'
        onChange={handleInputChange}
        classes={styles.input}
      />
    </li>
  )
}

TimeSlot.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
}

export default TimeSlot
